import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Header from './Header';
import Home from './Home';
import Footer from './Footer';
import About from './pages/About';
import Services from './pages/Services';
import Contact from './pages/Contact';
import WebDevelopment from './pages/WebDevelopment';
import MobileAppDevelopment from './pages/MobileAppDevelopment';
import CloudSolutions from './pages/CloudSolutions';
import ITSecurity from './pages/ITSecurity';
import Career from './pages/Career';
import Chatbot from './components/Chatbot';
import SoftwareProductPage from './pages/SoftwareProducts';
import ScrollToTop from './components/ScrollToTop'; // Import the ScrollToTop component
import GlobalStyles from './GlobalStyles';

const navigationLinks = [
  { path: '/', label: 'Home', exact: true },
  { path: '/about', label: 'About' },
  {
    path: '/services',
    label: 'Services',
    exact: true,
    subItems: [
      { path: '/services/web-development', label: 'Web Development' },
      { path: '/services/mobile-development', label: 'Mobile App Development' },
      { path: '/services/cloud-solutions', label: 'Cloud Solutions' },
      { path: '/services/it-security', label: 'IT Security' }
    ]
  },
  { path: '/career', label: 'Career' },
  { path: '/contact', label: 'Contact' }
];

const App = () => {
    return (
        <Router>
            <div>
                <GlobalStyles />
                <ScrollToTop /> {/* Add this line */}
                <Header navigation={navigationLinks} />
                <Switch>
                    <Route exact path="/" component={Home} />
                    <Route path="/about" component={About} />
                    <Route exact path="/services" component={Services} />
                    <Route path="/services/web-development" component={WebDevelopment} />
                    <Route path="/services/mobile-development" component={MobileAppDevelopment} />
                    <Route path="/services/cloud-solutions" component={CloudSolutions} />
                    <Route path="/services/it-security" component={ITSecurity} />
                    <Route path="/career" component={Career} />
                    <Route path="/contact" component={Contact} />
                    <Route path="/products/:productId" component={SoftwareProductPage} />
                </Switch>
                <Footer />
                <Chatbot />
            </div>
        </Router>
    );
};

export default App;
